module.exports = __webpack_public_path__ + "static/media/2022__K8A0174.851eb62d.jpg";